import React from 'react';

const Sidebar = ({ onApplyToAll, t }) => {

  return (
    <div className="col-lg-4">
      {/* Target Tips Card */}
      <div
        className="card border-0 rounded-3 text-white mb-4"
        style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}
      >
        <div className="card-body p-4">
          <h3 className="h5 fw-bold mb-4">{t('targetTips')}</h3>
          <ul className="list-unstyled mb-0">
            <li className="mb-3">
              <i className="bi bi-check-circle me-2"></i>
              {t('tipAchievableGoals')}
            </li>
            <li className="mb-3">
              <i className="bi bi-graph-up-arrow me-2"></i>
              {t('tipGradualIncrease')}
            </li>
            <li className="mb-0">
              <i className="bi bi-calendar-event me-2"></i>
              {t('tipWeekendDifferent')}
            </li>
          </ul>
        </div>
      </div>

      {/* Quick Actions Card */}
      <div className="card border rounded-3">
        <div className="card-body p-4">
          <h3 className="h6 fw-bold mb-4">{t('quickActions')}</h3>
          <button
            type="button"
            className="btn btn-outline-primary w-100 text-start"
            onClick={onApplyToAll}
            data-testid="apply-to-all-button"
          >
            <i className="bi bi-people-fill me-2"></i>
            <span>{t('applyToAllChildren')}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
